module.exports = __webpack_public_path__ + "assets/img/2_806_big.bc0c5401.jpg";